import * as React from 'react';

import { mapDispatchToActions } from '@/utils/store';

import actionCreators from './action-creators';
import reducer, { initialState } from './reducer';

export type State = typeof initialState;
export type Action = Record<keyof typeof actionCreators, Function>;

const filterStore = React.createContext<{
  state: State;
  actions: Action;
}>({
  state: initialState,
  actions: actionCreators,
});

const { Provider } = filterStore;

const FilterStateProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const actions = mapDispatchToActions(dispatch, actionCreators);

  return (
    <Provider
      value={{
        state,
        actions: actions as Record<keyof typeof actionCreators, React.Dispatch<Function>>,
      }}
    >
      {children}
    </Provider>
  );
};

export { FilterStateProvider as default, filterStore };
export * from './utils';
